<template>
  <div class="conversation-speech-bubble" :class="{ right: isSelf }">
    <router-link v-if="attachmentType === 'OrderItem'" class="content order" :to="url">
      <div class="d-flex align-center flex-wrap">
        <span class="name">{{ payload.flower.flower_specie.flower_genus.name }}</span>
        <span class="name">{{ payload.flower.flower_specie.name }}</span>
      </div>

      <div>
        {{ $t("expected_date") }}:
        <span class="value">
          {{ $d(payload.delivery_date, "shortDate") }}
          ({{ $d(payload.delivery_date, "day") }})
        </span>
      </div>

      <div v-if="payload.flower.flower_specie.image_url">
        <img
          :src="payload.flower.flower_specie.image_url"
          class="flower-img"
          @load="$emit('scrollBottom')"
        />
      </div>

      <div>
        <span class="value">{{ $n(price) }}</span>
        <span class="unit">円</span>
        <span class="value">{{ payload.count }}</span>
        <span class="unit">本</span>
      </div>

      <ChevronIcon class="arrow" size="24" />
    </router-link>

    <div v-else class="content text">
      <img
        v-if="payload"
        :src="payload.image_url"
        class="flower-img"
        @click="$emit('lightbox', payload.image_url)"
        @load="$emit('scrollBottom')"
      />
      <div>{{ message.body }}</div>
    </div>

    <div class="balloon-arrow" />
    <div class="state">
      <div v-if="isSelf && isRead" class="read">{{ $t("read") }}</div>
      <div class="date">{{ $d(message.created_at, "shortDateTime") }}</div>
    </div>
  </div>
</template>

<script>
import ChevronIcon from "@/components/icons/ChevronIcon.vue";
import { formatDate } from "@/plugins/i18n";

export default {
  components: {
    ChevronIcon
  },

  props: {
    message: {
      type: Object,
      required: true
    },
    hiddenLabel: {
      type: Boolean,
      required: false
    }
  },

  data() {
    return {
      accType: this.$route.matched[1].name
    };
  },

  computed: {
    isSelf() {
      return this.message.sender_type === this.accType;
    },

    isRead() {
      return this.message.status === "read";
    },

    attachmentType() {
      return this.message.attachment
        ? this.message.attachment.attachment_type
        : "";
    },

    payload() {
      return this.message.attachment ? this.message.attachment.payload : null;
    },

    url() {
      const accType = this.accType.toLowerCase();
      const date = formatDate(this.payload.delivery_date, "yyyy-mm-dd");

      if (accType === "shop") {
        return `/${accType}/orders?date=${date}`;
      } if (accType === "farm") {
        return `/${accType}/order_items?date=${date}`;
      }

      return "";
    },

    price() {
      return this.accType === "Shop"
        ? this.payload.unit_price_with_cavin_fee
        : this.payload.unit_price_without_cavin_fee;
    }
  }
};
</script>

<style lang="scss" scoped>
.conversation-speech-bubble {
  position: relative;
  max-width: 440px;
  background: #f5f5f5;
  border-radius: 5px;

  @media screen and (max-width: 960px) {
    max-width: 240px;
  }

  &.right {
    justify-self: end;

    .balloon-arrow {
      right: -8px;
      border-right: none;
    }

    .state {
      left: -8px;
      transform: translateX(-100%);
    }
  }

  &:not(.right) {
    justify-self: start;

    .balloon-arrow {
      left: -8px;
      border-left: none;
    }

    .state {
      right: -8px;
      transform: translateX(100%);
    }
  }
}

.content {
  padding: 16px;
  color: #777;
  font-size: 14px;

  &.text {
    white-space: pre-line;
  }
}

.balloon-arrow {
  position: absolute;
  top: 16px;
  border-color: transparent #f5f5f5;
  border-width: 6px 8px;
  border-style: solid;
}

.state {
  position: absolute;
  bottom: 0;
  color: #777;
  font-size: 10px;
  white-space: nowrap;
}

.order {
  display: grid;
  grid-template-columns: 1fr auto;
  grid-template-rows: auto auto auto;
  grid-auto-flow: column;
  grid-gap: 8px;
  padding-right: 8px;

  .name {
    font-weight: bold;
    margin-right: 8px;
  }

  .value {
    font-weight: bold;
  }

  .unit {
    margin: 0 8px 0 2px;
  }

  .arrow {
    fill: currentColor;
    grid-row: span 3;
    align-self: center;
  }
}
.flower-img {
  max-width: 100px;
}
</style>
